import { Address, State } from '@varo/graphql-schema-types';

export const getAddressText = (address?: Address): string => {
  return address
    ? `${address.addressLine1 ? address.addressLine1 + ',' : ''} ${address.addressLine2 ?? ''} \n${address.city ? address.city + ',' : ''} ${address.state ?? ''} ${address.zip ?? ''}`
    : '';
};

export const getStateAbbreviation = (states: State[], stateString: string) => {
  return (
    states.find((s) => s.abbreviation === stateString.split(' - ')[0])
      ?.abbreviation || ''
  );
};

export const getStateString = (state: State) => {
  return `${state.abbreviation} - ${state.name}`;
};

export const findFullStateString = (states: State[], abbreviation: string) => {
  if (!abbreviation) {
    return '';
  }
  const state = states.find((s) => s.abbreviation === abbreviation);
  if (state !== undefined) {
    return getStateString(state);
  }
};

export const getState = (state: State) => state.abbreviation;
